// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ad-accounts-tbody .tbody-adAccount{text-align:left;padding-left:30px}.ad-accounts-table .name{width:100%;flex-grow:0}.ad-accounts-table .create-date{text-align:left}.ad-accounts-table .adAccount{text-align:left;padding-left:50px}.ad-accounts-table .actions{text-align:left}.row-padding-margins{padding:0px !important;margin-bottom:-25px}", ""]);
// Exports
module.exports = exports;
